import { render, staticRenderFns } from "./VideoCreate.vue?vue&type=template&id=611b1000&scoped=true"
import script from "./VideoCreate.vue?vue&type=script&lang=ts"
export * from "./VideoCreate.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./VideoCreate.vue?vue&type=style&index=0&id=611b1000&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "611b1000",
  "6eba55e7"
  
)

export default component.exports